import { useMemo } from 'react'

import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { createColumnHelper } from '@tanstack/react-table'

import { Plus } from '@/components/icons'
import { PageCard, PageLayout } from '@/components/ui/page'
import {
	CellText,
	CellTextDate,
	DataTable,
	useDataTable,
} from '@/components/ui/table/data-table'

import { supplierList } from '@/features/outlet/api'
import type { IOutlet } from '@/features/outlet/type'

export const Route = createFileRoute('/_app/inventory/supplier/')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					[Route.fullPath, 'Supplier'],
				]}
			/>
			<SupplierTable />
		</PageLayout.Root>
	)
}

function SupplierTable() {
	const { data, isLoading } = useQuery(supplierList.qry({}))
	const columns = useMemo(getColumns, [])
	const { table } = useDataTable({
		columns,
		data: data?.suppliers ?? [],
	})

	return (
		<PageCard.Root>
			<PageCard.Header
				title="Suppliers"
				actions={
					<PageCard.HeaderAction asChild>
						<Link from={Route.fullPath} to="/inventory/supplier/create">
							<Plus /> Tambah supplier
						</Link>
					</PageCard.HeaderAction>
				}
			/>
			<PageCard.Content>
				<DataTable table={table} columns={columns} isLoading={isLoading} />
			</PageCard.Content>
		</PageCard.Root>
	)
}

const ch = createColumnHelper<IOutlet>()

function getColumns() {
	return [
		ch.accessor('name', {
			header: 'Name',
			cell: ({ row }) => {
				const { name, id } = row.original
				return (
					<CellText
						asLink
						text={
							<Link
								className="underline"
								from={Route.fullPath}
								to="/inventory/supplier/$id"
								params={{ id }}
							>
								{name}
							</Link>
						}
					/>
				)
			},
		}),
		ch.accessor('email', {
			header: 'Email',
			cell: ({ row }) => <CellText text={row.original.email} />,
		}),
		ch.accessor('phone', {
			header: 'Phone',
			cell: ({ row }) => <CellText text={row.original.phone} />,
		}),
		ch.accessor('address', {
			header: 'Address',
			cell: ({ row }) => <CellText text={row.original.address} />,
		}),
		ch.accessor('createdAt', {
			header: 'Created At',
			cell: ({ row }) => <CellTextDate date={row.original.createdAt} />,
		}),
		ch.accessor('updatedAt', {
			header: 'Updated At',
			cell: ({ row }) => <CellTextDate date={row.original.updatedAt} />,
		}),
	]
}
